<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('components.addDetailedAccount') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>

              <CCol sm="4">
                <CRow form class="form-group" >
                  <CCol tag="label" sm="3" class="col-form-label">
                    {{$t('components.searchUser')}}
                  </CCol>
                  <CCol sm="9" >
                    <treeselect
                        v-model="document_person"
                        :options="searched_person"

                        :async="search_user_async"
                        :load-options="load_persons"
                        :placeholder="$t('components.searchUser')"
                        :normalizer="normalizer_persons"
                    />

                  </CCol>
                </CRow>

              </CCol>
              <CCol col="4">
                <CInput
                    :label="$t('components.GroupLevel')"
                    horizontal
                    v-model="selected_level"

                />
              </CCol>


            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton v-if="status_form==0" @click="insert_data()" type="submit" size="sm" color="primary">
              <CIcon name="cil-check-circle"/>
              {{ $t('buttons.add') }}
            </CButton>
            <CButton v-if="status_form!=0" @click="insert_data()" type="submit" size="sm" color="success">
              <CIcon name="cil-check-circle"/>
              {{ $t('buttons.edit') }}
            </CButton>

            <CButton v-if="status_form!=0" @click="emptyList()" type="reset" size="sm" color="danger">
              <CIcon name="cil-ban"/>
              {{ $t('buttons.emptyForm') }}
            </CButton>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('components.DetailedAccounts') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CDataTable
                :items="items"
                :fields="fields"

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item}">

                <td style="text-align: center">
                  <p >{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #name="{item}">

                <td>
                  <p >{{ item.title }}</p>

                </td>

              </template>

              <template #summary="{item}">

                <td>
                  <p v-if="item.summary != 'null'">{{ item.summary }}</p>

                </td>

              </template>

              <template #color="{item}">

                <td>
                  <div :style="get_style(item.methodColor)">
                    {{ item.methodColor }}
                  </div>
                </td>

              </template>
              <template #operation="{item}">
                <td >

                  <CButton
                      class="m-1"
                      color="warning"
                      variant="outline"
                      square
                      size="sm"
                      :title="$t('buttons.delete')"
                      @click="edit_item(item)"
                  >
                    <CIcon name="cilPencil"/>
                  </CButton>
                  <CButton
                      class="m-1"
                      color="danger"
                      variant="outline"
                      square
                      size="sm"
                      :title="$t('buttons.delete')"
                      @click="delete_item_dialog(item)"
                  >
                    <CIcon name="cilTrash"/>
                  </CButton>

                </td>
              </template>


            </CDataTable>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
var simulateAsync=null
const simulateAsyncOperation = fn => {
  if(simulateAsync!=null){
    clearTimeout(simulateAsync)
  }
  simulateAsync =  setTimeout(fn, 1000)
}
var items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      validate_errors: [],
      selected_level: '',


      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},
        {key: 'accountName', label: this.$t('tables.bankAccTitle'), _style: 'width:10%'},
        {key: 'personName', label: this.$t('tables.name'), _style: 'width:10%'},
        {key: 'levelNo', label: this.$t('tables.level'), _style: 'width:10%'},

        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],

      status_form: 0,

      searched_person:[],
      document_person: null,
      search_user_async :true,
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros:true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {
                  console.log(error);
                });
          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },

    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on('delete_bank_confirm', (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },

  },
  methods: {
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.document_person != null && this.selected_level != '') {
        return true;
      }


      if (this.document_person == null) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectUser'));
      }
      if (this.selected_level == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertLevel'));
      }

      return false;
      // e.preventDefault();
    },

    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)

      this.selected_level = item.levelNo;
   this.search_user_async =false;

      this.searched_person = [{
        userId: item.personId,
        userName: item.personName,
      }];
      this.document_person = item.personId;
      this.search_user_async =false;

      this.status_form = item.recId;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },

    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      formData.append('Id', this.$route.params.group_id);


      axios.post('GetAccountTafsiliList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goToMembers(item) {

      this.$router.push({path: '/dashboard/accounting/sale-method-members/' + item.id});

    },

    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddAccountTafsili";
      } else {
        url = "EditAccountTafsili";
        formData.append('Id', this.status_form)

      }



      formData.append('AccountId', this.$route.params.group_id);
      formData.append('PersonId', this.document_person);
      formData.append('LevelNo', this.selected_level);

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {
        self.status_form = 0;

        self.document_person = null;
        self.selected_level = '';

        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_bank_confirm');

      this.status_form = item.recId;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteAccountTafsili";


      formData.append('Id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
